module.exports = __webpack_public_path__ + "static/36-6aa2a5ce9f58c29e51ca209eeccd3470.png";